// GET /api/shopify/lookup?sku=… on our server (server.js → shopify.js → Shopify).
import { baseApi } from '@/shared/api';

// What the server sends back for a SKU (see backend/shopify.js, lookupSku()).
export interface ShopProduct {
  sku: string; name: string; productTitle: string; variantTitle: string;
  price: string; compareAtPrice: string | null; description: string; url: string; warnings: string[];
}

const shopApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    lookupSku: b.query<ShopProduct, string>({ query: (sku) => ({ url: 'shopify/lookup', params: { sku } }), keepUnusedDataFor: 0 }),
  }),
});

export const { useLazyLookupSkuQuery } = shopApi;
